<template>
  <router-view />
</template>

<script>
export default {
};
</script>

<style lang="scss">
.ivu-message-custom-content {
  .ivu-icon-ios-information-circle {
    font-size: 20px;
  }
  span {
    font-size: 20px;
  }
  .ivu-icon-ios-checkmark-circle {
    font-size: 20px;
  }
}
.ivu-message-notice-close {
  top: 16px;
}
</style>
